import React from "react";
import { Link } from "react-router-dom";
import { MessageCircle, LogIn } from "lucide-react";
import { waHref } from "./utils";

export default function LandingNav() {
  return (
    <nav className="fixed top-0 left-0 right-0 h-16 z-40 bg-slate-950/85 backdrop-blur-md border-b border-slate-800 px-6 flex items-center justify-between">
      <a href="#top" className="flex items-center gap-3" data-testid="landing-brand">
        <div className="w-9 h-9 rounded bg-blue-600 flex items-center justify-center font-heading font-black text-lg">CG</div>
        <div className="font-heading text-lg font-extrabold uppercase tracking-wider">
          Cricket Graphics <span className="text-blue-500">Studio</span>
        </div>
      </a>
      <div className="hidden md:flex items-center gap-6 text-sm text-slate-300">
        <a href="#features" className="hover:text-white">Features</a>
        <a href="#video" className="hover:text-white">Walkthrough</a>
        <a href="#pricing" className="hover:text-white">Pricing</a>
        <a href="#faq" className="hover:text-white">FAQ</a>
      </div>
      <div className="flex items-center gap-2">
        <Link to="/login" data-testid="landing-signin"
          className="inline-flex items-center gap-2 px-3 py-2 rounded-lg bg-slate-800 hover:bg-slate-700 text-sm border border-slate-700">
          <LogIn size={14} /> Sign In
        </Link>
        <a href={waHref("Hi! I'd like to start with Cricket Graphics Studio.")} target="_blank" rel="noreferrer"
          data-testid="landing-wa-nav"
          className="hidden sm:inline-flex items-center gap-2 px-3 py-2 rounded-lg bg-emerald-600 hover:bg-emerald-700 text-sm font-semibold">
          <MessageCircle size={14} /> WhatsApp
        </a>
      </div>
    </nav>
  );
}
